import { MyClassResponse } from "@/interface/myClass";
import { API_BASE_URL } from "@/utils/api";
import { Dispatch, SetStateAction } from "react";

interface MyClassParams {
  id: number | string;
  token: string;
  setError: Dispatch<SetStateAction<string | null>>;
}

export const myClass = async ({
  id,
  token,
  setError,
}: MyClassParams): Promise<MyClassResponse | undefined> => {
  const response = await fetch(`${API_BASE_URL}/dashboard/${id}/my-classes`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const data: MyClassResponse = await response.json();

  if (response.status === 401) {
    setError("Sesi habis. Silakan login ulang.");
    return;
  }

  if (!response.ok || !data.success) {
    setError(data.message ?? "Gagal memuat data kelas.");
    return;
  }

  return data;
};
